/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddTaskExcuseCommandResult } from '../models/add-task-excuse-command-result';
import { AddTaskReportCommandResult } from '../models/add-task-report-command-result';
import { AddUnderSecretaryDecisionCommandResult } from '../models/add-under-secretary-decision-command-result';
import { apiTaskAddTaskExcusePut } from '../fn/task/api-task-add-task-excuse-put';
import { ApiTaskAddTaskExcusePut$Params } from '../fn/task/api-task-add-task-excuse-put';
import { apiTaskAddTaskExcusePut$Plain } from '../fn/task/api-task-add-task-excuse-put-plain';
import { ApiTaskAddTaskExcusePut$Plain$Params } from '../fn/task/api-task-add-task-excuse-put-plain';
import { apiTaskAddTaskReportPut } from '../fn/task/api-task-add-task-report-put';
import { ApiTaskAddTaskReportPut$Params } from '../fn/task/api-task-add-task-report-put';
import { apiTaskAddTaskReportPut$Plain } from '../fn/task/api-task-add-task-report-put-plain';
import { ApiTaskAddTaskReportPut$Plain$Params } from '../fn/task/api-task-add-task-report-put-plain';
import { apiTaskAddUnderSecretaryDecisionPut } from '../fn/task/api-task-add-under-secretary-decision-put';
import { ApiTaskAddUnderSecretaryDecisionPut$Params } from '../fn/task/api-task-add-under-secretary-decision-put';
import { apiTaskAddUnderSecretaryDecisionPut$Plain } from '../fn/task/api-task-add-under-secretary-decision-put-plain';
import { ApiTaskAddUnderSecretaryDecisionPut$Plain$Params } from '../fn/task/api-task-add-under-secretary-decision-put-plain';
import { apiTaskCreateTaskPost } from '../fn/task/api-task-create-task-post';
import { ApiTaskCreateTaskPost$Params } from '../fn/task/api-task-create-task-post';
import { apiTaskCreateTaskPost$Plain } from '../fn/task/api-task-create-task-post-plain';
import { ApiTaskCreateTaskPost$Plain$Params } from '../fn/task/api-task-create-task-post-plain';
import { apiTaskDeleteTaskDelete } from '../fn/task/api-task-delete-task-delete';
import { ApiTaskDeleteTaskDelete$Params } from '../fn/task/api-task-delete-task-delete';
import { apiTaskDeleteTaskDelete$Plain } from '../fn/task/api-task-delete-task-delete-plain';
import { ApiTaskDeleteTaskDelete$Plain$Params } from '../fn/task/api-task-delete-task-delete-plain';
import { apiTaskEditTaskReportPut } from '../fn/task/api-task-edit-task-report-put';
import { ApiTaskEditTaskReportPut$Params } from '../fn/task/api-task-edit-task-report-put';
import { apiTaskEditTaskReportPut$Plain } from '../fn/task/api-task-edit-task-report-put-plain';
import { ApiTaskEditTaskReportPut$Plain$Params } from '../fn/task/api-task-edit-task-report-put-plain';
import { apiTaskEditUnderSecretaryDecisionPut } from '../fn/task/api-task-edit-under-secretary-decision-put';
import { ApiTaskEditUnderSecretaryDecisionPut$Params } from '../fn/task/api-task-edit-under-secretary-decision-put';
import { apiTaskEditUnderSecretaryDecisionPut$Plain } from '../fn/task/api-task-edit-under-secretary-decision-put-plain';
import { ApiTaskEditUnderSecretaryDecisionPut$Plain$Params } from '../fn/task/api-task-edit-under-secretary-decision-put-plain';
import { apiTaskGenerateTaskPdfIdGet } from '../fn/task/api-task-generate-task-pdf-id-get';
import { ApiTaskGenerateTaskPdfIdGet$Params } from '../fn/task/api-task-generate-task-pdf-id-get';
import { apiTaskGetTaskGet } from '../fn/task/api-task-get-task-get';
import { ApiTaskGetTaskGet$Params } from '../fn/task/api-task-get-task-get';
import { apiTaskGetTaskGet$Plain } from '../fn/task/api-task-get-task-get-plain';
import { ApiTaskGetTaskGet$Plain$Params } from '../fn/task/api-task-get-task-get-plain';
import { apiTaskGetTasksGet } from '../fn/task/api-task-get-tasks-get';
import { ApiTaskGetTasksGet$Params } from '../fn/task/api-task-get-tasks-get';
import { apiTaskGetTasksGet$Plain } from '../fn/task/api-task-get-tasks-get-plain';
import { ApiTaskGetTasksGet$Plain$Params } from '../fn/task/api-task-get-tasks-get-plain';
import { apiTaskPauseTaskPut } from '../fn/task/api-task-pause-task-put';
import { ApiTaskPauseTaskPut$Params } from '../fn/task/api-task-pause-task-put';
import { apiTaskPauseTaskPut$Plain } from '../fn/task/api-task-pause-task-put-plain';
import { ApiTaskPauseTaskPut$Plain$Params } from '../fn/task/api-task-pause-task-put-plain';
import { apiTaskReferTaskToPut } from '../fn/task/api-task-refer-task-to-put';
import { ApiTaskReferTaskToPut$Params } from '../fn/task/api-task-refer-task-to-put';
import { apiTaskReferTaskToPut$Plain } from '../fn/task/api-task-refer-task-to-put-plain';
import { ApiTaskReferTaskToPut$Plain$Params } from '../fn/task/api-task-refer-task-to-put-plain';
import { apiTaskResumeTaskPut } from '../fn/task/api-task-resume-task-put';
import { ApiTaskResumeTaskPut$Params } from '../fn/task/api-task-resume-task-put';
import { apiTaskResumeTaskPut$Plain } from '../fn/task/api-task-resume-task-put-plain';
import { ApiTaskResumeTaskPut$Plain$Params } from '../fn/task/api-task-resume-task-put-plain';
import { apiTaskUpdateTaskPut } from '../fn/task/api-task-update-task-put';
import { ApiTaskUpdateTaskPut$Params } from '../fn/task/api-task-update-task-put';
import { apiTaskUpdateTaskPut$Plain } from '../fn/task/api-task-update-task-put-plain';
import { ApiTaskUpdateTaskPut$Plain$Params } from '../fn/task/api-task-update-task-put-plain';
import { CreateTaskCommandResult } from '../models/create-task-command-result';
import { DeleteTaskCommandResult } from '../models/delete-task-command-result';
import { EditTaskReportCommandResult } from '../models/edit-task-report-command-result';
import { EditUnderSecretaryDecisionCommandResult } from '../models/edit-under-secretary-decision-command-result';
import { GetTaskQueryResult } from '../models/get-task-query-result';
import { GetTasksQueryResult } from '../models/get-tasks-query-result';
import { PauseTaskCommandResult } from '../models/pause-task-command-result';
import { ReferTaskToCommandResult } from '../models/refer-task-to-command-result';
import { ResumeTaskCommandResult } from '../models/resume-task-command-result';
import { UpdateTaskCommandResult } from '../models/update-task-command-result';

@Injectable({ providedIn: 'root' })
export class TaskService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTaskGetTaskGet()` */
  static readonly ApiTaskGetTaskGetPath = '/api/Task/GetTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskGetTaskGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaskGetTaskGet$Plain$Response(params?: ApiTaskGetTaskGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTaskQueryResult>> {
    return apiTaskGetTaskGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskGetTaskGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaskGetTaskGet$Plain(params?: ApiTaskGetTaskGet$Plain$Params, context?: HttpContext): Observable<GetTaskQueryResult> {
    return this.apiTaskGetTaskGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetTaskQueryResult>): GetTaskQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskGetTaskGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaskGetTaskGet$Response(params?: ApiTaskGetTaskGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTaskQueryResult>> {
    return apiTaskGetTaskGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskGetTaskGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaskGetTaskGet(params?: ApiTaskGetTaskGet$Params, context?: HttpContext): Observable<GetTaskQueryResult> {
    return this.apiTaskGetTaskGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetTaskQueryResult>): GetTaskQueryResult => r.body)
    );
  }

  /** Path part for operation `apiTaskGetTasksGet()` */
  static readonly ApiTaskGetTasksGetPath = '/api/Task/GetTasks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskGetTasksGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaskGetTasksGet$Plain$Response(params?: ApiTaskGetTasksGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTasksQueryResult>> {
    return apiTaskGetTasksGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskGetTasksGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaskGetTasksGet$Plain(params?: ApiTaskGetTasksGet$Plain$Params, context?: HttpContext): Observable<GetTasksQueryResult> {
    return this.apiTaskGetTasksGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetTasksQueryResult>): GetTasksQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskGetTasksGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaskGetTasksGet$Response(params?: ApiTaskGetTasksGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTasksQueryResult>> {
    return apiTaskGetTasksGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskGetTasksGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaskGetTasksGet(params?: ApiTaskGetTasksGet$Params, context?: HttpContext): Observable<GetTasksQueryResult> {
    return this.apiTaskGetTasksGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetTasksQueryResult>): GetTasksQueryResult => r.body)
    );
  }

  /** Path part for operation `apiTaskCreateTaskPost()` */
  static readonly ApiTaskCreateTaskPostPath = '/api/Task/CreateTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskCreateTaskPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskCreateTaskPost$Plain$Response(params?: ApiTaskCreateTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateTaskCommandResult>> {
    return apiTaskCreateTaskPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskCreateTaskPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskCreateTaskPost$Plain(params?: ApiTaskCreateTaskPost$Plain$Params, context?: HttpContext): Observable<CreateTaskCommandResult> {
    return this.apiTaskCreateTaskPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateTaskCommandResult>): CreateTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskCreateTaskPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskCreateTaskPost$Response(params?: ApiTaskCreateTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateTaskCommandResult>> {
    return apiTaskCreateTaskPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskCreateTaskPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskCreateTaskPost(params?: ApiTaskCreateTaskPost$Params, context?: HttpContext): Observable<CreateTaskCommandResult> {
    return this.apiTaskCreateTaskPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateTaskCommandResult>): CreateTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskUpdateTaskPut()` */
  static readonly ApiTaskUpdateTaskPutPath = '/api/Task/UpdateTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskUpdateTaskPut$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskUpdateTaskPut$Plain$Response(params?: ApiTaskUpdateTaskPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateTaskCommandResult>> {
    return apiTaskUpdateTaskPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskUpdateTaskPut$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskUpdateTaskPut$Plain(params?: ApiTaskUpdateTaskPut$Plain$Params, context?: HttpContext): Observable<UpdateTaskCommandResult> {
    return this.apiTaskUpdateTaskPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateTaskCommandResult>): UpdateTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskUpdateTaskPut()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskUpdateTaskPut$Response(params?: ApiTaskUpdateTaskPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateTaskCommandResult>> {
    return apiTaskUpdateTaskPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskUpdateTaskPut$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskUpdateTaskPut(params?: ApiTaskUpdateTaskPut$Params, context?: HttpContext): Observable<UpdateTaskCommandResult> {
    return this.apiTaskUpdateTaskPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateTaskCommandResult>): UpdateTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskAddTaskReportPut()` */
  static readonly ApiTaskAddTaskReportPutPath = '/api/Task/AddTaskReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskAddTaskReportPut$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskAddTaskReportPut$Plain$Response(params?: ApiTaskAddTaskReportPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddTaskReportCommandResult>> {
    return apiTaskAddTaskReportPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskAddTaskReportPut$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskAddTaskReportPut$Plain(params?: ApiTaskAddTaskReportPut$Plain$Params, context?: HttpContext): Observable<AddTaskReportCommandResult> {
    return this.apiTaskAddTaskReportPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddTaskReportCommandResult>): AddTaskReportCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskAddTaskReportPut()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskAddTaskReportPut$Response(params?: ApiTaskAddTaskReportPut$Params, context?: HttpContext): Observable<StrictHttpResponse<AddTaskReportCommandResult>> {
    return apiTaskAddTaskReportPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskAddTaskReportPut$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskAddTaskReportPut(params?: ApiTaskAddTaskReportPut$Params, context?: HttpContext): Observable<AddTaskReportCommandResult> {
    return this.apiTaskAddTaskReportPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddTaskReportCommandResult>): AddTaskReportCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskAddUnderSecretaryDecisionPut()` */
  static readonly ApiTaskAddUnderSecretaryDecisionPutPath = '/api/Task/AddUnderSecretaryDecision';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskAddUnderSecretaryDecisionPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskAddUnderSecretaryDecisionPut$Plain$Response(params?: ApiTaskAddUnderSecretaryDecisionPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddUnderSecretaryDecisionCommandResult>> {
    return apiTaskAddUnderSecretaryDecisionPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskAddUnderSecretaryDecisionPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskAddUnderSecretaryDecisionPut$Plain(params?: ApiTaskAddUnderSecretaryDecisionPut$Plain$Params, context?: HttpContext): Observable<AddUnderSecretaryDecisionCommandResult> {
    return this.apiTaskAddUnderSecretaryDecisionPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddUnderSecretaryDecisionCommandResult>): AddUnderSecretaryDecisionCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskAddUnderSecretaryDecisionPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskAddUnderSecretaryDecisionPut$Response(params?: ApiTaskAddUnderSecretaryDecisionPut$Params, context?: HttpContext): Observable<StrictHttpResponse<AddUnderSecretaryDecisionCommandResult>> {
    return apiTaskAddUnderSecretaryDecisionPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskAddUnderSecretaryDecisionPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskAddUnderSecretaryDecisionPut(params?: ApiTaskAddUnderSecretaryDecisionPut$Params, context?: HttpContext): Observable<AddUnderSecretaryDecisionCommandResult> {
    return this.apiTaskAddUnderSecretaryDecisionPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddUnderSecretaryDecisionCommandResult>): AddUnderSecretaryDecisionCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskReferTaskToPut()` */
  static readonly ApiTaskReferTaskToPutPath = '/api/Task/ReferTaskTo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskReferTaskToPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskReferTaskToPut$Plain$Response(params?: ApiTaskReferTaskToPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ReferTaskToCommandResult>> {
    return apiTaskReferTaskToPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskReferTaskToPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskReferTaskToPut$Plain(params?: ApiTaskReferTaskToPut$Plain$Params, context?: HttpContext): Observable<ReferTaskToCommandResult> {
    return this.apiTaskReferTaskToPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReferTaskToCommandResult>): ReferTaskToCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskReferTaskToPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskReferTaskToPut$Response(params?: ApiTaskReferTaskToPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ReferTaskToCommandResult>> {
    return apiTaskReferTaskToPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskReferTaskToPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskReferTaskToPut(params?: ApiTaskReferTaskToPut$Params, context?: HttpContext): Observable<ReferTaskToCommandResult> {
    return this.apiTaskReferTaskToPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReferTaskToCommandResult>): ReferTaskToCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskDeleteTaskDelete()` */
  static readonly ApiTaskDeleteTaskDeletePath = '/api/Task/DeleteTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskDeleteTaskDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskDeleteTaskDelete$Plain$Response(params?: ApiTaskDeleteTaskDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteTaskCommandResult>> {
    return apiTaskDeleteTaskDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskDeleteTaskDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskDeleteTaskDelete$Plain(params?: ApiTaskDeleteTaskDelete$Plain$Params, context?: HttpContext): Observable<DeleteTaskCommandResult> {
    return this.apiTaskDeleteTaskDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteTaskCommandResult>): DeleteTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskDeleteTaskDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskDeleteTaskDelete$Response(params?: ApiTaskDeleteTaskDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteTaskCommandResult>> {
    return apiTaskDeleteTaskDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskDeleteTaskDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskDeleteTaskDelete(params?: ApiTaskDeleteTaskDelete$Params, context?: HttpContext): Observable<DeleteTaskCommandResult> {
    return this.apiTaskDeleteTaskDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteTaskCommandResult>): DeleteTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskPauseTaskPut()` */
  static readonly ApiTaskPauseTaskPutPath = '/api/Task/PauseTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskPauseTaskPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskPauseTaskPut$Plain$Response(params?: ApiTaskPauseTaskPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PauseTaskCommandResult>> {
    return apiTaskPauseTaskPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskPauseTaskPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskPauseTaskPut$Plain(params?: ApiTaskPauseTaskPut$Plain$Params, context?: HttpContext): Observable<PauseTaskCommandResult> {
    return this.apiTaskPauseTaskPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PauseTaskCommandResult>): PauseTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskPauseTaskPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskPauseTaskPut$Response(params?: ApiTaskPauseTaskPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PauseTaskCommandResult>> {
    return apiTaskPauseTaskPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskPauseTaskPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskPauseTaskPut(params?: ApiTaskPauseTaskPut$Params, context?: HttpContext): Observable<PauseTaskCommandResult> {
    return this.apiTaskPauseTaskPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<PauseTaskCommandResult>): PauseTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskResumeTaskPut()` */
  static readonly ApiTaskResumeTaskPutPath = '/api/Task/ResumeTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskResumeTaskPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskResumeTaskPut$Plain$Response(params?: ApiTaskResumeTaskPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ResumeTaskCommandResult>> {
    return apiTaskResumeTaskPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskResumeTaskPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskResumeTaskPut$Plain(params?: ApiTaskResumeTaskPut$Plain$Params, context?: HttpContext): Observable<ResumeTaskCommandResult> {
    return this.apiTaskResumeTaskPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResumeTaskCommandResult>): ResumeTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskResumeTaskPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskResumeTaskPut$Response(params?: ApiTaskResumeTaskPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ResumeTaskCommandResult>> {
    return apiTaskResumeTaskPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskResumeTaskPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskResumeTaskPut(params?: ApiTaskResumeTaskPut$Params, context?: HttpContext): Observable<ResumeTaskCommandResult> {
    return this.apiTaskResumeTaskPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResumeTaskCommandResult>): ResumeTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskEditTaskReportPut()` */
  static readonly ApiTaskEditTaskReportPutPath = '/api/Task/EditTaskReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskEditTaskReportPut$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskEditTaskReportPut$Plain$Response(params?: ApiTaskEditTaskReportPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EditTaskReportCommandResult>> {
    return apiTaskEditTaskReportPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskEditTaskReportPut$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskEditTaskReportPut$Plain(params?: ApiTaskEditTaskReportPut$Plain$Params, context?: HttpContext): Observable<EditTaskReportCommandResult> {
    return this.apiTaskEditTaskReportPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditTaskReportCommandResult>): EditTaskReportCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskEditTaskReportPut()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskEditTaskReportPut$Response(params?: ApiTaskEditTaskReportPut$Params, context?: HttpContext): Observable<StrictHttpResponse<EditTaskReportCommandResult>> {
    return apiTaskEditTaskReportPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskEditTaskReportPut$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaskEditTaskReportPut(params?: ApiTaskEditTaskReportPut$Params, context?: HttpContext): Observable<EditTaskReportCommandResult> {
    return this.apiTaskEditTaskReportPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditTaskReportCommandResult>): EditTaskReportCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskEditUnderSecretaryDecisionPut()` */
  static readonly ApiTaskEditUnderSecretaryDecisionPutPath = '/api/Task/EditUnderSecretaryDecision';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskEditUnderSecretaryDecisionPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskEditUnderSecretaryDecisionPut$Plain$Response(params?: ApiTaskEditUnderSecretaryDecisionPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EditUnderSecretaryDecisionCommandResult>> {
    return apiTaskEditUnderSecretaryDecisionPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskEditUnderSecretaryDecisionPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskEditUnderSecretaryDecisionPut$Plain(params?: ApiTaskEditUnderSecretaryDecisionPut$Plain$Params, context?: HttpContext): Observable<EditUnderSecretaryDecisionCommandResult> {
    return this.apiTaskEditUnderSecretaryDecisionPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditUnderSecretaryDecisionCommandResult>): EditUnderSecretaryDecisionCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskEditUnderSecretaryDecisionPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskEditUnderSecretaryDecisionPut$Response(params?: ApiTaskEditUnderSecretaryDecisionPut$Params, context?: HttpContext): Observable<StrictHttpResponse<EditUnderSecretaryDecisionCommandResult>> {
    return apiTaskEditUnderSecretaryDecisionPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskEditUnderSecretaryDecisionPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskEditUnderSecretaryDecisionPut(params?: ApiTaskEditUnderSecretaryDecisionPut$Params, context?: HttpContext): Observable<EditUnderSecretaryDecisionCommandResult> {
    return this.apiTaskEditUnderSecretaryDecisionPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditUnderSecretaryDecisionCommandResult>): EditUnderSecretaryDecisionCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskAddTaskExcusePut()` */
  static readonly ApiTaskAddTaskExcusePutPath = '/api/Task/AddTaskExcuse';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskAddTaskExcusePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskAddTaskExcusePut$Plain$Response(params?: ApiTaskAddTaskExcusePut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddTaskExcuseCommandResult>> {
    return apiTaskAddTaskExcusePut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskAddTaskExcusePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskAddTaskExcusePut$Plain(params?: ApiTaskAddTaskExcusePut$Plain$Params, context?: HttpContext): Observable<AddTaskExcuseCommandResult> {
    return this.apiTaskAddTaskExcusePut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddTaskExcuseCommandResult>): AddTaskExcuseCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskAddTaskExcusePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskAddTaskExcusePut$Response(params?: ApiTaskAddTaskExcusePut$Params, context?: HttpContext): Observable<StrictHttpResponse<AddTaskExcuseCommandResult>> {
    return apiTaskAddTaskExcusePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskAddTaskExcusePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaskAddTaskExcusePut(params?: ApiTaskAddTaskExcusePut$Params, context?: HttpContext): Observable<AddTaskExcuseCommandResult> {
    return this.apiTaskAddTaskExcusePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddTaskExcuseCommandResult>): AddTaskExcuseCommandResult => r.body)
    );
  }

  /** Path part for operation `apiTaskGenerateTaskPdfIdGet()` */
  static readonly ApiTaskGenerateTaskPdfIdGetPath = '/api/Task/GenerateTaskPdf/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaskGenerateTaskPdfIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaskGenerateTaskPdfIdGet$Response(params: ApiTaskGenerateTaskPdfIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiTaskGenerateTaskPdfIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaskGenerateTaskPdfIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaskGenerateTaskPdfIdGet(params: ApiTaskGenerateTaskPdfIdGet$Params, context?: HttpContext): Observable<void> {
    return this.apiTaskGenerateTaskPdfIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
